<template lang="html">
  <b-container>
    <b-row class="mt-5">
      <b-col md="6" offset="3">
        <h1>Soundslides 3</h1>
        <h2 class="mt-4 mb-5">No connection to service</h2>

        <p v-if="retrying">
          <b-alert show>
            Attempting connection ... <b-spinner small label="Spinning" />
          </b-alert>
        </p>
        <p v-if="stillError">
          <b-alert show variant="warning">
            Connection failed.
          </b-alert>
        </p>
        <p v-if="!retrying">
          <b-btn @click="retryConnection">Retry Connection</b-btn>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { db } from "@/fstore";
export default {
  name: "ServiceUnavailable",
  data() {
    return {
      retrying: false,
      stillError: false
    };
  },
  methods: {
    retryConnection() {
      this.retrying = true;
      this.stillError = false;
      var _v = this;
      // Confirmation only occurs after a successful .get().
      // onSnapshot does not return an error when user is offline.
      // .get() does.
      var user_id = this.$store.state.user.uid;
      db.collection("users")
        .doc(user_id)
        .get()
        .then(function(doc) {
          // Connection for real.
          console.log(doc);
          _v.$store.commit("setServiceUnavailable", false);
        })
        .catch(function(error) {
          // Still offline, show error again.
          console.log(error);
          setTimeout(function() {
            _v.retrying = false;
            _v.stillError = true;
          }, 2000);
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
